import store from './store'
import NikanApp from './plugins/nikan-app'
import NikanUI from './plugins/nikanUI'
import NikanModalStorage from './plugins/nikan-modal-plugin'
import Mixins from './plugins/nikan-mixins'
import NikanWait from './plugins/nikan-waiting-plugin'
import NikanCache from './plugins/nikan-cache-plugin'
import ComponentRegistrar from './plugins/components.js'
import router from './plugins/router'
import mitt from 'mitt'
import { Events } from './statics/events'
const emitter = mitt<Events>()

//@ts-ignore
import Endpoints from '@nikan/endpoints'
import i18n, { hotreload } from '~/plugins/localization'
import app from './plugins/vue-instance.js'
import { ObserveVisibility } from 'vue-observe-visibility'
//@ts-ignore
import SalaryEditor from '@nikan/salaryeditor'

// toast
import 'vue-toastification/dist/index.css'
import Toast, { toastInstance, toastOptions } from '~/plugins/toast.js'

import axios from 'axios'

import KeyHandler from '@nikan/key-handler'
import 'bootstrap'

import $ from 'jquery'

// @ts-ignore
window.$ = window.jQuery = $

import './statics/scripts.dep.js'
import './statics/javascript.prototypes.js'
import './statics/jquery.prototypes.js'
import './statics/validators.js'
import './statics/string.prototypes.js'



app.config.globalProperties.$http = axios
app.config.globalProperties.$toast = toastInstance
app.config.globalProperties.$emitter = emitter

//@ts-ignore
app.$toast = toastInstance

// KeyHandler.Configure({ loggerEnabled: false, observe: true })
// @ts-ignore
app.use(KeyHandler)
app.use(NikanApp)
app.use(NikanUI)
app.use(NikanModalStorage)
app.use(Mixins)
app.use(NikanWait)
app.use(NikanCache)
app.use(i18n)
app.use(router)
app.use(Toast, toastOptions)
app.use(store)
app.use(ComponentRegistrar)
app.use(SalaryEditor)

app.directive('observe-visibility', ObserveVisibility)

Endpoints.register(store)
router.isReady().then(() => {
  app.mount('#app')
})

import packageJson from '../package.json'
document.title = packageJson.title

hotreload(app)
